import { InvoiceInput, InvoiceResponse, RunSaveAsInvoiceInput } from '@/models/gen/graphql';

import { GraphApiResponse } from '@/api/core';
import { RunSaveAsInvoiceDocument } from '@/api/queries';
import createGraphApiHook from '@/hooks/createGraphApiHook';
import graphApi from '@/api';

type RunSaveAsInvoiceGraphApiResponse = GraphApiResponse<typeof RunSaveAsInvoiceDocument>;

const title = 'Save New Invoice';

const runSaveAsInvoiceResponseSelector = (res: RunSaveAsInvoiceGraphApiResponse): InvoiceResponse =>
  !res.errors ? (res?.runSaveAsInvoice?.output as InvoiceResponse) : undefined;

const [runRunSaveAsInvoice] = graphApi(RunSaveAsInvoiceDocument, {});

export const runSaveAsInvoice = async (invoice: InvoiceInput): Promise<InvoiceResponse> => {
  const input: RunSaveAsInvoiceInput = { input: invoice };
  const res = await runRunSaveAsInvoice({ input });

  const selected = runSaveAsInvoiceResponseSelector(res);
  return selected;
};

export const useRunSaveAsInvoice = createGraphApiHook(runSaveAsInvoice);

export default runSaveAsInvoice;
